import { Translation } from "../lib/i18n";

export const formatLabels = {
  de: {
    month: "Monat",
    months: "Monate",
    year: "Jahr",
    years: "Jahre",
  },
  en: {
    month: "month",
    months: "months",
    year: "year",
    years: "years",
  },
} as const satisfies Translation;

export const offerLabels = {
  de: {
    legalNotice:
      "Repräsentatives Beispiel für {productProviderName} vermittelt durch Justhome GmbH, Brunnenstraße 196, 10119 Berlin, Bonität erforderlich. {interestRate} gebundener Sollzins / {effectiveInterest} effektiver Jahreszins,{fixedInterestPeriodInYears} Darlehensbetrag {loanAmount}. Gesamtanzahl der Raten: {totalDuration}, Darlehenslaufzeit: {loanTermYears} Jahre {loanTermMonths} Monat(e), Höhe der Rate: {monthlyInstallment}. Zu zahlende Gesamtsumme: {totalCost}. {dept}",
    debt: "Erstrangige Besicherung des Darlehens durch Grundschuld erforderlich.",
    fixedInterestPeriod: " {fixedInterestPeriodInYears} Jahre Sollzinsbindung,",
    label: "Rechtshinweise",
    maybeDebt:
      "Erstrangige Besicherung des Darlehens durch Grundschuld kann erforderlich sein.",
    interestRate: "Sollzinssatz",
    effectiveInterestRate: "Effektiver Zinssatz",
    repaymentRate: "Tilgungsrate",
    residualDebt: "Restschuld",
    yearsDative: "Jahren",
    monthly: "monatlich",
    lowestInterestRate: "niedrigster Sollzinssatz",
    lowestMonthlyInstallment: "niedrigste Monatsrate",
    lowestBaseRate: "niedrigste Zinsen & Monatsrate",
    interestPeriod: "Zinsbindung",
    with: "mit",
    sustainableDefinition:
      "Dieses Darlehen wird nur für den Kauf einer „grünen” Immobilie gewährt. Eine „grüne” Immobilie ist eine Art von Immobilie, die so konzipiert ist, dass sie ökologisch nachhaltig ist. Grüne Immobilien konzentrieren sich auf die effiziente Nutzung von Energie, Wasser und Baumaterialien.",
    sustainableDefinitionMore:
      " Eine grüne Immobilie kann nachhaltig beschaffte, umweltfreundliche und/oder recycelte Baumaterialien verwenden. Sie kann nachhaltige Energiequellen wie Solarenergie oder Erdwärme nutzen und so gelegen sein, dass sie die natürlichen Gegebenheiten wie Sonnenlicht und Baumbestand optimal nutzt, um die Energieeffizienz zu verbessern.",
    sustainableDefinitionTitle: "„Grünes” Darlehen",
    readFullDefinition: "Ganze Definition anzeigen",
    conditionalTitle: "Unter Vorbehalt",
    conditionalDescription:
      "Die Bank stellt gewisse Bedingungen für diese Finanzierung. Sprich uns an.",
    monthlyInstallment: "Monatliche Rate",
    residualDept: "Restschuld",
    loanDuration: "Laufzeit",
    loanDurationInfo:
      "Kalkulatorische Laufzeit des Darlehens bis es vollständig zurückgezahlt ist. Diese Rechnung unterstellt, dass die Zinskonditionen auch über die anfängliche Zinsbindung hinaus unverändert bleiben.",
    interestAfterFixedPeriod: "Gesamtzinszahlung",
    interestAfterFixedPeriodInfo:
      "Gesamtbetrag der Zinsen, die über die Laufzeit der Zinsbindung gezahlt werden.",
    hideDetails: "Details ausblenden",
    showDetails: "Details anzeigen",
    combination: "Kombi-Finanzierung",
    kfwCombination: "Inklusive KfW Darlehen",
    standardCombination:
      "Diese Finanzierung kombiniert mehrere Darlehen für optimale Konditionen.",
    expirationDate: "Gültig bis:",
  },
  en: {
    legalNotice:
      "Representative example for {productProviderName} brokered by Justhome GmbH, Brunnenstraße 196, 10119 Berlin, creditworthiness required. {interestRate} fixed interest rate / {effectiveInterest} effective annual interest rate,{fixedInterestPeriodInYears} loan amount {loanAmount}. Total number of installments: {totalDuration}, Loan term: {loanTermYears} years {loanTermMonths} month(s), Installment amount: {monthlyInstallment}, Total amount to be paid: {totalCost}. {dept}",
    debt: "Unsubordinated debt is necessary.",
    fixedInterestPeriod: " {fixedInterestPeriodInYears} Jahre Sollzinsbindung,",
    label: "Legal notice",
    maybeDebt: "Unsubordinated debt may be necessary.",
    interestRate: "Interest rate",
    effectiveInterestRate: "Effective interest rate",
    repaymentRate: "Repayment rate",
    residualDebt: "Residual debt",
    yearsDative: "years",
    monthly: "monthly",
    lowestInterestRate: "lowest interest rate",
    lowestMonthlyInstallment: "lowest installment",
    lowestBaseRate: "lowest installment & interest rate",
    lowestMonthlyInstallmentShort: "lowest installment",
    interestPeriod: "interest period",
    with: "with",
    sustainableDefinition:
      "This loan is provided only for the purchase of “green” home. A green home is a type of house designed to be environmentally sustainable. Green homes focus on the efficient use of “energy, water, and building materials”.",
    sustainableDefinitionMore:
      " A green home may use sustainably sourced, environmentally friendly, and/or recycled building materials. It may include sustainable energy sources such as solar or geothermal, and be sited to take maximum advantage of natural features such as sunlight and tree cover to improve energy efficiency.",
    sustainableDefinitionTitle: "“Green” mortgage",
    readFullDefinition: "Read full definition",
    conditionalTitle: "Subject to certain conditions",
    conditionalDescription:
      "The bank has certain conditions for this financing. Talk to us.",
    monthlyInstallment: "Monthly installment",
    residualDept: "Residual dept",
    loanDuration: "Loan term",
    loanDurationInfo:
      "Imputed term of the loan until it is fully repaid. This calculation assumes that the interest rate conditions remain unchanged beyond the initial fixed-interest period.",
    interestAfterFixedPeriod: "Total interest payment",
    interestAfterFixedPeriodInfo:
      "Total amount of interest paid over the term of the fixed interest rate.",
    hideDetails: "Hide details",
    showDetails: "Show details",
    combination: "Combination financing",
    kfwCombination: "Including KfW loan",
    standardCombination:
      "This financing combines several loans for optimal conditions.",
    expirationDate: "Valid until:",
  },
} as const satisfies Translation;
